<h4 class="section-title">Alternative Tools</h4>
<table mat-table #altTable="matTable" class="dense-table mat-elevation-z0" [dataSource]="alternativeTools().controls">
    <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef>Tool Name</th>
        <td mat-cell *matCellDef="let row" [formGroup]="row">
            <mat-form-field appearance="outline" floatLabel="always"
                class="mat-form-field-no-margin">
                <mat-select formControlName="relatedToolId"
                    aria-label="Alternative tool" placeholder="Select tool"
                    (openedChange)="onSelectOpened(row, $event)"
                    (selectionChange)="onSelectionChange(row, $event)">
                    <mat-option class="select-search-option" [value]="alternativeToolSearchValue">
                        <input class="select-search-input alternative-tool"
                            type="text" placeholder="Search tools..."
                            autocomplete="off" aria-label="Search tools"
                            [value]="alternativeToolFilter()"
                            (input)="onFilterInput($event)"
                            (mousedown)="$event.stopPropagation()"
                            (pointerdown)="$event.stopPropagation()"
                            (click)="$event.stopPropagation()"
                            (keydown)="$event.stopPropagation()"/>
                    </mat-option>
                    @if (toolOptionsLoading()) {
                        <mat-option disabled>Loading tools…</mat-option>
                    } @else if (toolOptionsError()) {
                        <mat-option disabled>{{ toolOptionsError() }}</mat-option>
                    } @else {
                        @for (opt of filteredToolOptions(); track opt.id) {
                            <mat-option [value]="opt.id">{{ opt.name }}</mat-option>
                        }
                    }
                </mat-select>
            </mat-form-field>
        </td>
    </ng-container>

    <ng-container matColumnDef="relationshipType">
        <th mat-header-cell *matHeaderCellDef>Relationship</th>
        <td mat-cell *matCellDef="let row" [formGroup]="row">
            <mat-form-field appearance="outline" floatLabel="always" 
                class="mat-form-field-no-margin">
                <mat-select formControlName="relationshipType"
                    aria-label="Relationship type">
                    @for (opt of relationshipOptions;track opt.value) {
                        <mat-option [value]="opt.value">{{opt.label}}</mat-option>
                    }
                </mat-select>
            </mat-form-field>
        </td>
    </ng-container>

    <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef class="icon-col" ></th>
        <td mat-cell *matCellDef="let row; let i = index"
            class="text-right actions-cell">
            <button type="button" class="icon-btn icon-btn--ms danger"
                (click)="removeTool(i)">
                <span class="material-symbols-outlined">delete</span>
            </button>
        </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="['name','relationshipType','actions']"></tr>
    <tr mat-row *matRowDef="let row; columns: [ 'name', 'relationshipType','actions']"></tr>
    <tr class="mat-row" *ngIf="alternativeTools().length === 0">
        <td class="mat-cell" colspan="3">No alternative tools yet.</td>
    </tr>
</table>
<div class="link-row">
    <button type="button" class="link-btn" (click)="addTool()">
        + add alternative tool
    </button>
</div>
